import { all, takeLatest, call, put } from "redux-saga/effects";
import { GET_ALLOW_PROFILE, SEARCH_TIN, VALIDATE_TIN } from "./constans";
import * as api from "../../../utils/api";
import { API_URL } from "../../../utils/axios";
import {
  getAllowProfileSuccess,
  getAllowProfileFailed,
  validateTinFailed,
  validateTinSuccess,
  searchTinSuccess,
  searchTinFailed,
} from "./actions";

import { sendLogError } from "../../../utils/api";

let logError = {};

function* allowProfileUpdateSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/allow_update_profile`
    );
    const { data } = res;

    if (data.errorCode) {
      logError.api = res.url || window.location.pathname;
      logError.message = data.message || "---";
      logError.errorResponse = true;
      logError.status = res.status || "Not Found";
      logError.errorCode = data.errorCode;

      sendLogError(logError);
      throw new Error("fail get allow update profile value");
    }

    if (typeof data === "object" && "value" in data) {
      const converted = { ...data };
      if (converted.value === "false") {
        converted.value = false;
      }
      if (converted.value === "true") {
        converted.value = true;
      }

      yield put(getAllowProfileSuccess(converted));
    } else {
      sendLogError(data);
      throw new Error("fail get allow update profile value");
    }
  } catch (error) {
    yield put(getAllowProfileFailed());
  }
}

function* validateTINSaga({ callback, payload }) {
  let err;
  try {
    const res = yield call(
      api.post,
      `${API_URL.mp}/mp/customer/validate-tin`,
      payload
    );
    const { data } = res;

    if (data.errorCode) {
      logError.api = res.url || window.location.pathname;
      logError.message = data.message || "---";
      logError.errorResponse = true;
      logError.status = res.status || "Not Found";
      logError.errorCode = data.errorCode;

      sendLogError(logError);
      throw data;
    }

    yield put(validateTinSuccess());
  } catch (error) {
    err = error;
    yield put(validateTinFailed());
  } finally {
    callback(err);
  }
}

function* searchTINSaga({ payload }) {
  let err;
  try {
    console.log("payload: ", payload);

    const { idType, idNo } = payload;
    const res = yield call(
      api.get,
      `${API_URL.mp}/mp/customer/search-tin?idType=${idType}&idNo=${idNo}`
    );

    console.log("res: ", res);

    const { data, status, statusText } = res;

    if (status !== 200) {
      logError.api = res.url || window.location.pathname;
      logError.message = data.message || "---";
      logError.errorResponse = true;
      logError.status = statusText || "Not Found";
      logError.errorCode = status;

      sendLogError(logError);
      throw data;
    }

    yield put(searchTinSuccess(data.lhdnResponse.tin));
  } catch (error) {
    err = error;
    yield put(searchTinFailed());
  }
}

export function* profileWorkerSaga() {
  yield all([
    takeLatest(GET_ALLOW_PROFILE, allowProfileUpdateSaga),
    takeLatest(VALIDATE_TIN, validateTINSaga),
    takeLatest(SEARCH_TIN, searchTINSaga),
  ]);
}
